<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none" v-if="userData.role != 'admin' && userData.role != 'adminBranch'">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-md-flex" v-if="userData.role != 'admin' && userData.role != 'adminBranch'">

      <!-- Bookmarks Container -->
      <!-- <bookmarks /> -->
      <show-balance/>
      <!-- <div class="d-none d-lg-flex">
        <div class="vl ml-1">
          <div class="pl-1">
            <h5 >เรทฝากสั่ง</h5>
            <h5 class="pl-1">{{this.rate.sellRate}}</h5>
          </div>
        </div>
        <div class="vl ml-1">
          <div class="pl-1">
            <h5 >เรทฝากจ่าย</h5>
            <h5 class="pl-1">{{this.rate.topUpRate}}</h5>
          </div>
        </div>
         <div class="vl ml-1">
          <div class="pl-1">
            <h5 >เรทโอนธนาคาร/Alipay</h5>
            <h5 class="pl-1">{{this.rate.transferRate}}</h5>
            <small>(ขั้นต่ำ 5000 หยวน ก่อนโอนติดต่อผ่านทางไลน์เท่านั้น)</small>
          </div>
        </div>
      </div> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <show-text />
      <!-- <locale /> -->
      <dark-Toggler class="d-none d-lg-block" v-if="userData.role != 'admin' && userData.role != 'adminBranch'"/>
      <!-- <search-bar /> -->
      <coupon v-if="userData.role != 'admin' && userData.role != 'adminBranch'"/>
      <cart-dropdown v-if="userData.role != 'admin' && userData.role != 'adminBranch'"/>
      <!-- <notification-dropdown /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import ShowBalance from './components/ShowBalance.vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import ShowText from './components/Text.vue'
import Coupon from './components/Coupon.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
    ShowText,
    ShowBalance,
    Coupon
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      rate: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      seeExchangeRate: false
    };
  },

  watch:{
    async $route (to, from){
      // await this.isSeeExchange()
      if (this.userData.role != 'admin' && this.userData.role != 'adminBranch') {
        this.getRate()
      }
    }
  },

  async created() {
    // await this.isSeeExchange()
    if (this.userData.role != 'admin' && this.userData.role != 'adminBranch') {
      this.getRate()
    }
  },
  methods: {
    async getRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.rate = response.data
      localStorage.setItem('exchange_rate', JSON.stringify(response.data))
    },

    async isSeeExchange() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/see-exchange-rate',
        {
          "loginToken": this.userData.data.customerInfo.loginToken
        },
        { headers: header_token }
      )
      this.seeExchangeRate = response.data
    }
  },
  
}
</script>
<style >
  .vl {
    border-left: 1px solid ;
    height: 55px;
  }
</style>
